export var detachArrayBuffer = function detachArrayBuffer(arrayBuffer) {
  var _MessageChannel = new MessageChannel(),
      port1 = _MessageChannel.port1,
      port2 = _MessageChannel.port2;

  return new Promise(function (resolve) {
    var closeAndResolve = function closeAndResolve() {
      port2.onmessage = null;
      port1.close();
      port2.close();
      resolve();
    };

    port2.onmessage = function () {
      return closeAndResolve();
    };

    try {
      port1.postMessage(arrayBuffer, [arrayBuffer]);
    } finally {
      closeAndResolve();
    }
  });
};